import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGame = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M18 6h-5c0-1.7-1.3-3-3-3H6c-.6 0-1-.4-1-1s.4-1 1-1h13.5c.3 0 .5-.2.5-.5s-.2-.5-.5-.5H6C4.9 0 4 .9 4 2s.9 2 2 2h4c1.1 0 2 .9 2 2H6c-3.3 0-6 2.7-6 6v8c0 2.2 1.8 4 4 4 1.1 0 2.1-.4 2.8-1.2l4.6-4.7c.2-.1.3-.2.5-.2s.4.1.5.2l4.6 4.7c.7.7 1.7 1.2 2.8 1.2 2.2 0 4-1.8 4-4v-8c.2-3.3-2.5-6-5.8-6zm4 14c0 1.1-.9 2-2 2-.6 0-1.1-.2-1.4-.6l-4.5-4.5s-.9-.9-2.1-.9-2.1.9-2.1.9l-4.5 4.5c-.3.4-.8.6-1.4.6-1.1 0-2-.9-2-2v-8c0-2.2 1.8-4 4-4h12c2.2 0 4 1.8 4 4v8z" }),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17,
			cy: 15,
			r: 1
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 17,
			cy: 11,
			r: 1
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 15,
			cy: 13,
			r: 1
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 19,
			cy: 13,
			r: 1
		}),
		/* @__PURE__ */ _jsx("path", { d: "M9 12H8v-1c0-.6-.4-1-1-1s-1 .4-1 1v1H5c-.6 0-1 .4-1 1s.4 1 1 1h1v1c0 .6.4 1 1 1s1-.4 1-1v-1h1c.6 0 1-.4 1-1s-.4-1-1-1z" })
	]
});
export default SvgGame;
